
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';

    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Imagen } from '@/__env/lib/Articulos/Imagenes';
    import { Wait } from '@/__env/ext';
    import { Atributo } from '@/__env/lib/Articulos/Atributos';

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Cargando: boolean;

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Articulo() { return this.Controlador.Articulo; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Nombre: string = '';
        @Watch( 'Nombre' )
        onNombre()
        {
            if ( !this.Atributo.Existe )
            {
                this.Atributo.Descripcion = this.Nombre;
            }

        }

        public Valor: string = '';
        @Watch( 'Valor' )
        onValor()
        {
            this.Atributo.Valor = this.Valor;
            if ( !this.Atributo.Existe )
            {
                this.$emit( 'agregar' );
            }

        }

        @Prop()
        public Atributo: Atributo;
        @Watch( 'Abributo' )
        onAbributo()
        {
            if ( this.Atributo )
                this.Iniciar();
        }
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Iniciar();
        }

        NoCorresponde()
        {
            this.Atributo.NoCorresponde = true;
            this.Valor = 'No corresponde';
        }

        Corresponde()
        {
            this.Atributo.NoCorresponde = false;
            this.Valor = '';
        }
        Iniciar()
        {
            if ( this.Estado != 'iniciado' )
                return;

            if ( this.Atributo )
            {
                this.Nombre = this.Atributo.Descripcion;
                this.Valor = this.Atributo.Valor;
            }


        }

        public async Guardar()
        {

            if ( !this.Nombre || !this.Valor )
                return;


            this.Atributo.Descripcion = this.Nombre;
            this.Atributo.Valor = this.Valor;

            this.$emit( 'guardado' );
        }

        public async Eliminar()
        {
            if ( !await Utiles.Mensajes.SiNo( 'Eliminar atributo', '¿Está seguro?' ) )
                return;

            this.Valor = '';
            this.Nombre = '';
            this.$emit( 'eliminar', this.Atributo );
        }



    }
